module.exports = __webpack_public_path__ + "img/bancaubi-logo-no-bg.5310bfee.png";